import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2cfa8c87"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "FastMemoryRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "以下为题目和选项", -1));
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "flex flex-col"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  const _component_el_col = _resolveComponent("el-col");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_el_row, {
    key: 1
  }, {
    default: _withCtx(() => [$data.visible < 2 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "点击按钮，你将有" + _toDisplayString($props.difficulty.flashInterval) + "秒钟时间记忆展示的图形", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_5, "现在请选出所有刚刚展示过的图形"))]),
    _: 1
  })), !$props.reviewMode && $data.visible == 0 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 2,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      size: "large",
      type: "primary",
      onClick: $options.showExample
    }, {
      default: _withCtx(() => [_createTextVNode("展示图形")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })) : _createCommentVNode("", true), $props.reviewMode || $data.visible == 1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 3,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.question, q => {
      return _openBlock(), _createElementBlock("div", {
        style: {
          "width": "10%",
          "margin-left": "1%"
        },
        key: q
      }, [_createElementVNode("img", {
        src: q,
        class: "sqr90"
      }, null, 8, _hoisted_6)]);
    }), 128))]),
    _: 1
  })) : _createCommentVNode("", true), $props.reviewMode || $data.visible == 2 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 4,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createVNode(_component_AnswerButtonGroup, {
      onChoose: $options.onChoosed,
      "option-width": "90px",
      "option-both-center": false,
      review: $props.review,
      ref: "answerBtns",
      single: false,
      reviewMode: $props.reviewMode,
      options: $data.options.slice(0, $props.data.options.length)
    }, {
      default: _withCtx(btnIndex => [_createElementVNode("img", {
        src: $props.data.options[btnIndex.index],
        class: "sqr90"
      }, null, 8, _hoisted_7)]),
      _: 1
    }, 8, ["onChoose", "review", "reviewMode", "options"])]),
    _: 1
  })) : _createCommentVNode("", true), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 5,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_col, {
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.answer.join(',')), 1)]),
      _: 1
    }), $props.review ? (_openBlock(), _createBlock(_component_el_col, {
      key: 0,
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        style: _normalizeStyle({
          color: $props.review.result ? 'green' : 'red'
        })
      }, "您的答案：" + _toDisplayString($props.review.answer), 5)]),
      _: 1
    })) : _createCommentVNode("", true)])]),
    _: 1
  })) : _createCommentVNode("", true)]);
}